import { Component, OnInit } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { venue_returndata } from 'src/types/venue_returndata';
import { venue } from 'src/types/venue';
import { bmxurl, getAccess } from 'src/globals';
import { time } from 'src/types/times'
import { venuestarttimes } from 'src/types/venuestarttimes';
import { venuestarttimes_returndata } from 'src/types/venuestarttimes_returndata';
import { cVenuesettings } from 'src/types/venuesettings';
import { cVenuesetting } from 'src/types/venuesetting';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { GlobalService } from '../_services/global.service';
import { users_returndata } from 'src/types/user_returndata';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { host_returndata } from 'src/types/host_returndata';

//A single failed validation, and where on the page the user needs to be taken to fix it.
//tabIndex: 0 = Venue Details, 1 = Settings, 2 = Social Media.
//accordionIndex is only meaningful on the Settings tab: 0 = General, 2 = Visual.
interface cValidationIssue {
  message: string;
  tabIndex: number;
  accordionIndex?: number;
  fieldId?: string;
}

@Component({
  selector: 'app-venuesettings',
  templateUrl: './venuesettings.component.html',
  styleUrls: ['./venuesettings.component.css']
})
export class VenuesettingsComponent implements OnInit {

  venueStartTimes: any;
  VenueReturnData: any;
  Venue: any;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  PostCodeAPIResult: any;
  SelectedTimes: any;
  minutesInbetween: number = 1;
  diagnosticsModeStateOptions: any;
  minimalDetailsStateOptions: any;
  includeParticipants: any;
  ConfirmationsStateOptions: any;
  defInterval: number = 5;

  httpResponse: any;
  venuesettings: cVenuesettings;
  venueSettingsId: string = "9b5db9e3-3b5a-404f-ae48-6b10b06bcbc7";

  VenueStartTimeSetID: any;

  alltimes: any[] = ['00:00','00:01','00:02','00:03','00:04','00:05','00:06','00:07','00:08','00:09','00:10','00:11','00:12','00:13','00:14','00:15','00:16','00:17','00:18','00:19','00:20','00:21','00:22','00:23','00:24','00:25','00:26','00:27','00:28','00:29','00:30','00:31','00:32','00:33','00:34','00:35','00:36','00:37','00:38','00:39','00:40','00:41','00:42','00:43','00:44','00:45','00:46','00:47','00:48','00:49','00:50','00:51','00:52','00:53','00:54','00:55','00:56','00:57','00:58','00:59','01:00','01:01','01:02','01:03','01:04','01:05','01:06','01:07','01:08','01:09','01:10','01:11','01:12','01:13','01:14','01:15','01:16','01:17','01:18','01:19','01:20','01:21','01:22','01:23','01:24','01:25','01:26','01:27','01:28','01:29','01:30','01:31','01:32','01:33','01:34','01:35','01:36','01:37','01:38','01:39','01:40','01:41','01:42','01:43','01:44','01:45','01:46','01:47','01:48','01:49','01:50','01:51','01:52','01:53','01:54','01:55','01:56','01:57','01:58','01:59','02:00','02:01','02:02','02:03','02:04','02:05','02:06','02:07','02:08','02:09','02:10','02:11','02:12','02:13','02:14','02:15','02:16','02:17','02:18','02:19','02:20','02:21','02:22','02:23','02:24','02:25','02:26','02:27','02:28','02:29','02:30','02:31','02:32','02:33','02:34','02:35','02:36','02:37','02:38','02:39','02:40','02:41','02:42','02:43','02:44','02:45','02:46','02:47','02:48','02:49','02:50','02:51','02:52','02:53','02:54','02:55','02:56','02:57','02:58','02:59','03:00','03:01','03:02','03:03','03:04','03:05','03:06','03:07','03:08','03:09','03:10','03:11','03:12','03:13','03:14','03:15','03:16','03:17','03:18','03:19','03:20','03:21','03:22','03:23','03:24','03:25','03:26','03:27','03:28','03:29','03:30','03:31','03:32','03:33','03:34','03:35','03:36','03:37','03:38','03:39','03:40','03:41','03:42','03:43','03:44','03:45','03:46','03:47','03:48','03:49','03:50','03:51','03:52','03:53','03:54','03:55','03:56','03:57','03:58','03:59','04:00','04:01','04:02','04:03','04:04','04:05','04:06','04:07','04:08','04:09','04:10','04:11','04:12','04:13','04:14','04:15','04:16','04:17','04:18','04:19','04:20','04:21','04:22','04:23','04:24','04:25','04:26','04:27','04:28','04:29','04:30','04:31','04:32','04:33','04:34','04:35','04:36','04:37','04:38','04:39','04:40','04:41','04:42','04:43','04:44','04:45','04:46','04:47','04:48','04:49','04:50','04:51','04:52','04:53','04:54','04:55','04:56','04:57','04:58','04:59','05:00','05:01','05:02','05:03','05:04','05:05','05:06','05:07','05:08','05:09','05:10','05:11','05:12','05:13','05:14','05:15','05:16','05:17','05:18','05:19','05:20','05:21','05:22','05:23','05:24','05:25','05:26','05:27','05:28','05:29','05:30','05:31','05:32','05:33','05:34','05:35','05:36','05:37','05:38','05:39','05:40','05:41','05:42','05:43','05:44','05:45','05:46','05:47','05:48','05:49','05:50','05:51','05:52','05:53','05:54','05:55','05:56','05:57','05:58','05:59','06:00','06:01','06:02','06:03','06:04','06:05','06:06','06:07','06:08','06:09','06:10','06:11','06:12','06:13','06:14','06:15','06:16','06:17','06:18','06:19','06:20','06:21','06:22','06:23','06:24','06:25','06:26','06:27','06:28','06:29','06:30','06:31','06:32','06:33','06:34','06:35','06:36','06:37','06:38','06:39','06:40','06:41','06:42','06:43','06:44','06:45','06:46','06:47','06:48','06:49','06:50','06:51','06:52','06:53','06:54','06:55','06:56','06:57','06:58','06:59','07:00','07:01','07:02','07:03','07:04','07:05','07:06','07:07','07:08','07:09','07:10','07:11','07:12','07:13','07:14','07:15','07:16','07:17','07:18','07:19','07:20','07:21','07:22','07:23','07:24','07:25','07:26','07:27','07:28','07:29','07:30','07:31','07:32','07:33','07:34','07:35','07:36','07:37','07:38','07:39','07:40','07:41','07:42','07:43','07:44','07:45','07:46','07:47','07:48','07:49','07:50','07:51','07:52','07:53','07:54','07:55','07:56','07:57','07:58','07:59','08:00','08:01','08:02','08:03','08:04','08:05','08:06','08:07','08:08','08:09','08:10','08:11','08:12','08:13','08:14','08:15','08:16','08:17','08:18','08:19','08:20','08:21','08:22','08:23','08:24','08:25','08:26','08:27','08:28','08:29','08:30','08:31','08:32','08:33','08:34','08:35','08:36','08:37','08:38','08:39','08:40','08:41','08:42','08:43','08:44','08:45','08:46','08:47','08:48','08:49','08:50','08:51','08:52','08:53','08:54','08:55','08:56','08:57','08:58','08:59','09:00','09:01','09:02','09:03','09:04','09:05','09:06','09:07','09:08','09:09','09:10','09:11','09:12','09:13','09:14','09:15','09:16','09:17','09:18','09:19','09:20','09:21','09:22','09:23','09:24','09:25','09:26','09:27','09:28','09:29','09:30','09:31','09:32','09:33','09:34','09:35','09:36','09:37','09:38','09:39','09:40','09:41','09:42','09:43','09:44','09:45','09:46','09:47','09:48','09:49','09:50','09:51','09:52','09:53','09:54','09:55','09:56','09:57','09:58','09:59','10:00','10:01','10:02','10:03','10:04','10:05','10:06','10:07','10:08','10:09','10:10','10:11','10:12','10:13','10:14','10:15','10:16','10:17','10:18','10:19','10:20','10:21','10:22','10:23','10:24','10:25','10:26','10:27','10:28','10:29','10:30','10:31','10:32','10:33','10:34','10:35','10:36','10:37','10:38','10:39','10:40','10:41','10:42','10:43','10:44','10:45','10:46','10:47','10:48','10:49','10:50','10:51','10:52','10:53','10:54','10:55','10:56','10:57','10:58','10:59','11:00','11:01','11:02','11:03','11:04','11:05','11:06','11:07','11:08','11:09','11:10','11:11','11:12','11:13','11:14','11:15','11:16','11:17','11:18','11:19','11:20','11:21','11:22','11:23','11:24','11:25','11:26','11:27','11:28','11:29','11:30','11:31','11:32','11:33','11:34','11:35','11:36','11:37','11:38','11:39','11:40','11:41','11:42','11:43','11:44','11:45','11:46','11:47','11:48','11:49','11:50','11:51','11:52','11:53','11:54','11:55','11:56','11:57','11:58','11:59','12:00','12:01','12:02','12:03','12:04','12:05','12:06','12:07','12:08','12:09','12:10','12:11','12:12','12:13','12:14','12:15','12:16','12:17','12:18','12:19','12:20','12:21','12:22','12:23','12:24','12:25','12:26','12:27','12:28','12:29','12:30','12:31','12:32','12:33','12:34','12:35','12:36','12:37','12:38','12:39','12:40','12:41','12:42','12:43','12:44','12:45','12:46','12:47','12:48','12:49','12:50','12:51','12:52','12:53','12:54','12:55','12:56','12:57','12:58','12:59','13:00','13:01','13:02','13:03','13:04','13:05','13:06','13:07','13:08','13:09','13:10','13:11','13:12','13:13','13:14','13:15','13:16','13:17','13:18','13:19','13:20','13:21','13:22','13:23','13:24','13:25','13:26','13:27','13:28','13:29','13:30','13:31','13:32','13:33','13:34','13:35','13:36','13:37','13:38','13:39','13:40','13:41','13:42','13:43','13:44','13:45','13:46','13:47','13:48','13:49','13:50','13:51','13:52','13:53','13:54','13:55','13:56','13:57','13:58','13:59','14:00','14:01','14:02','14:03','14:04','14:05','14:06','14:07','14:08','14:09','14:10','14:11','14:12','14:13','14:14','14:15','14:16','14:17','14:18','14:19','14:20','14:21','14:22','14:23','14:24','14:25','14:26','14:27','14:28','14:29','14:30','14:31','14:32','14:33','14:34','14:35','14:36','14:37','14:38','14:39','14:40','14:41','14:42','14:43','14:44','14:45','14:46','14:47','14:48','14:49','14:50','14:51','14:52','14:53','14:54','14:55','14:56','14:57','14:58','14:59','15:00','15:01','15:02','15:03','15:04','15:05','15:06','15:07','15:08','15:09','15:10','15:11','15:12','15:13','15:14','15:15','15:16','15:17','15:18','15:19','15:20','15:21','15:22','15:23','15:24','15:25','15:26','15:27','15:28','15:29','15:30','15:31','15:32','15:33','15:34','15:35','15:36','15:37','15:38','15:39','15:40','15:41','15:42','15:43','15:44','15:45','15:46','15:47','15:48','15:49','15:50','15:51','15:52','15:53','15:54','15:55','15:56','15:57','15:58','15:59','16:00','16:01','16:02','16:03','16:04','16:05','16:06','16:07','16:08','16:09','16:10','16:11','16:12','16:13','16:14','16:15','16:16','16:17','16:18','16:19','16:20','16:21','16:22','16:23','16:24','16:25','16:26','16:27','16:28','16:29','16:30','16:31','16:32','16:33','16:34','16:35','16:36','16:37','16:38','16:39','16:40','16:41','16:42','16:43','16:44','16:45','16:46','16:47','16:48','16:49','16:50','16:51','16:52','16:53','16:54','16:55','16:56','16:57','16:58','16:59','17:00','17:01','17:02','17:03','17:04','17:05','17:06','17:07','17:08','17:09','17:10','17:11','17:12','17:13','17:14','17:15','17:16','17:17','17:18','17:19','17:20','17:21','17:22','17:23','17:24','17:25','17:26','17:27','17:28','17:29','17:30','17:31','17:32','17:33','17:34','17:35','17:36','17:37','17:38','17:39','17:40','17:41','17:42','17:43','17:44','17:45','17:46','17:47','17:48','17:49','17:50','17:51','17:52','17:53','17:54','17:55','17:56','17:57','17:58','17:59','18:00','18:01','18:02','18:03','18:04','18:05','18:06','18:07','18:08','18:09','18:10','18:11','18:12','18:13','18:14','18:15','18:16','18:17','18:18','18:19','18:20','18:21','18:22','18:23','18:24','18:25','18:26','18:27','18:28','18:29','18:30','18:31','18:32','18:33','18:34','18:35','18:36','18:37','18:38','18:39','18:40','18:41','18:42','18:43','18:44','18:45','18:46','18:47','18:48','18:49','18:50','18:51','18:52','18:53','18:54','18:55','18:56','18:57','18:58','18:59','19:00','19:01','19:02','19:03','19:04','19:05','19:06','19:07','19:08','19:09','19:10','19:11','19:12','19:13','19:14','19:15','19:16','19:17','19:18','19:19','19:20','19:21','19:22','19:23','19:24','19:25','19:26','19:27','19:28','19:29','19:30','19:31','19:32','19:33','19:34','19:35','19:36','19:37','19:38','19:39','19:40','19:41','19:42','19:43','19:44','19:45','19:46','19:47','19:48','19:49','19:50','19:51','19:52','19:53','19:54','19:55','19:56','19:57','19:58','19:59','20:00','20:01','20:02','20:03','20:04','20:05','20:06','20:07','20:08','20:09','20:10','20:11','20:12','20:13','20:14','20:15','20:16','20:17','20:18','20:19','20:20','20:21','20:22','20:23','20:24','20:25','20:26','20:27','20:28','20:29','20:30','20:31','20:32','20:33','20:34','20:35','20:36','20:37','20:38','20:39','20:40','20:41','20:42','20:43','20:44','20:45','20:46','20:47','20:48','20:49','20:50','20:51','20:52','20:53','20:54','20:55','20:56','20:57','20:58','20:59','21:00','21:01','21:02','21:03','21:04','21:05','21:06','21:07','21:08','21:09','21:10','21:11','21:12','21:13','21:14','21:15','21:16','21:17','21:18','21:19','21:20','21:21','21:22','21:23','21:24','21:25','21:26','21:27','21:28','21:29','21:30','21:31','21:32','21:33','21:34','21:35','21:36','21:37','21:38','21:39','21:40','21:41','21:42','21:43','21:44','21:45','21:46','21:47','21:48','21:49','21:50','21:51','21:52','21:53','21:54','21:55','21:56','21:57','21:58','21:59','22:00','22:01','22:02','22:03','22:04','22:05','22:06','22:07','22:08','22:09','22:10','22:11','22:12','22:13','22:14','22:15','22:16','22:17','22:18','22:19','22:20','22:21','22:22','22:23','22:24','22:25','22:26','22:27','22:28','22:29','22:30','22:31','22:32','22:33','22:34','22:35','22:36','22:37','22:38','22:39','22:40','22:41','22:42','22:43','22:44','22:45','22:46','22:47','22:48','22:49','22:50','22:51','22:52','22:53','22:54','22:55','22:56','22:57','22:58','22:59','23:00','23:01','23:02','23:03','23:04','23:05','23:06','23:07','23:08','23:09','23:10','23:11','23:12','23:13','23:14','23:15','23:16','23:17','23:18','23:19','23:20','23:21','23:22','23:23','23:24','23:25','23:26','23:27','23:28','23:29','23:30','23:31','23:32','23:33','23:34','23:35','23:36','23:37','23:38','23:39','23:40','23:41','23:42','23:43','23:44','23:45','23:46','23:47','23:48','23:49','23:50','23:51','23:52','23:53','23:54','23:55','23:56','23:57','23:58','23:59'];

  venueStartTime: string;
  venueEndTime: string;

  venueStartTimeHours: any[];
  venueStartTimeMins: any[];

  venueEndTimeHours: any[];
  venueEndTimeMins: any[];
  
  venueSelectedStartTimeHours: string;
  venueSelectedStartTimeMins: string;

  venueSelectedEndTimeHours: string;
  venueSelectedEndTimeMins: string;

  mondaySelectedTimes: any[] = [];
  tuesdaySelectedTimes: any[] = [];
  wednesdaySelectedTimes: any[] = [];
  thursdaySelectedTimes: any[] = [];
  fridaySelectedTimes: any[] = [];
  saturdaySelectedTimes: any[] = [];
  sundaySelectedTimes: any[] = [];

  mondayTemplate: any[];
  tuesdayTemplate: any[];
  wednesdayTemplate: any[];
  thursdayTemplate: any[];
  fridayTemplate: any[];
  saturdayTemplate: any[];
  sundayTemplate: any[];

  mondaySelectedTemplate: any[];
  tuesdaySelectedTemplate: any[];
  wednesdaySelectedTemplate: any[];
  thursdaySelectedTemplate: any[];
  fridaySelectedTemplate: any[];
  saturdaySelectedTemplate: any[];
  sundaySelectedTemplate: any[];

  venueMondayStartTimeHours: any[];
  venueMondayStartTimeMins: any[];
  venueTuesdayStartTimeHours: any[];
  venueTuesdayStartTimeMins: any[];
  venueWednesdayStartTimeHours: any[];
  venueWednesdayStartTimeMins: any[];
  venueThursdayStartTimeHours: any[];
  venueThursdayStartTimeMins: any[];
  venueFridayStartTimeHours: any[];
  venueFridayStartTimeMins: any[];
  venueSaturdayStartTimeHours: any[];
  venueSaturdayStartTimeMins: any[];
  venueSundayStartTimeHours: any[];
  venueSundayStartTimeMins: any[];

  venueMondaySelectedStartTimeHours: any;
  venueMondaySelectedStartTimeMins: any;
  venueTuesdaySelectedStartTimeHours: any;
  venueTuesdaySelectedStartTimeMins: any;
  venueWednesdaySelectedStartTimeHours: any;
  venueWednesdaySelectedStartTimeMins: any;
  venueThursdaySelectedStartTimeHours: any;
  venueThursdaySelectedStartTimeMins: any;
  venueFridaySelectedStartTimeHours: any;
  venueFridaySelectedStartTimeMins: any;
  venueSaturdaySelectedStartTimeHours: any;
  venueSaturdaySelectedStartTimeMins: any;
  venueSundaySelectedStartTimeHours: any;
  venueSundaySelectedStartTimeMins: any;

  startTimeIndex: number;
  endTimeIndex: number;

  capacityValid: boolean = true;
  emailValid: boolean = true;
  venueNameValid: boolean = true;
  addressValid: boolean = true;
  imageReturnURLValid: boolean = true;
  imageReturnURLFormatValid: boolean = true;
  returnPageValid: boolean = true;
  activeTabIndex: number = 0;
  settingsAccordionIndex: number | null = null;
  countyValid: boolean = true;
  townValid: boolean = true;
  postcodeValid: boolean = true;
  phoneValid: boolean = true;

  //Settings variables
  vsDiagnostics: boolean = true;
  vsPBWStyle: string = "DATEFIRST";
  vsMinimalDetails: boolean = true;
  vsImageURL: string = "";
  vsImageReturnURL: string = "";
  vsImageMode: 'url' | 'upload' = 'url';
  vsImageGuid: string = uuidv4();

  vsImageModeOptions = [
    { label: 'Enter URL', value: 'url' },
    { label: 'Upload Image', value: 'upload' },
  ];
  vsGTMCode: string = "";
  venuestarttimeindex = 0;
  venueendtimeindex = 0;
  vsConfirmations: string;
  defaultColour: string = "#FFFFFF";
  defaultBackgroundColour: string = "#FFFFFF";
  defaultTextColour: string = "#000000";
  defaultButtonTextColour: string = "#FFFFFF";
  defaultSummaryBackgroundColour: string = "#FFFFFF";
  defaultSummaryHeaderFooterColour: string = "#DDDDDD";
  defaultSummaryHeaderFooterTextColour: string = "#000000";
  defaultSummaryTextColour: string = "#000000";
  vsprefix: string;

  imageWidth:number;
  imageHeight: number;

  VCapacityIncludesParticipant: boolean = false;
  idleTimeout: number;
  AllowTimeOut: boolean = false;
  prefixValid: boolean = true;
  prefix: string = "";

  RyftSubAccountID: string = "";
  GoogleTagManagerID: string = "";

  returnPage: string = "";

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  Currencies: any[] = [];
  chosenCurrency: any;

  timezones: any[] = [];
  chosenTimezone: any;

  PaymentAmountSelection: any = "DEPOSIT";
  paymentAmountStateOptions: any[] = [];

  EmailTemplates: any[] = [];
  selectedPaymentLinkEmailTemplate: any;
  selectedVoucherEmailTemplate: any;
  VoucherValidity: number = 12;
  VoucherValidityOptions: {label: string, value: number}[] = Array.from({length: 120}, (_, i) => ({label: `${i + 1} month${i === 0 ? '' : 's'}`, value: i + 1}));

  delayBookingStateOptions: any[] = [];
  intinerarySummaryStateOptions: any[] = [];
  BookingsCannotBeMadeWithinXMinutes: number = 0;
  BookingsCannotBeMadeAfterXMinutes: number = 0;
  CannotMakeBookingsToday: boolean = false;

  //The venue's own customer services details. Confirmations and email templates start from
  //these rather than having them typed in again for every one.
  CustomerServiceEmail: string = "";
  CustomerServicePhone: string = "";

  UseCounters: boolean = false;
  SummaryItinerary: boolean = false;
  SummaryItineraryVenue: boolean = false;

  PublicHostName: string = "";
  PublicHostNameVoucher: string = "";
  PublicHostNameMembership: string = "";
  PublicHostNameScheduledSession: string = "";
  PublicHostNameEvents: string = "";
  PublicWaiverForGroup: string = "";

  BNemail: string = "";
  BookingNotification: boolean = false;
  BNStateOptions: any[] = [];

  StopPublicBookings: boolean = false;
  StopPublicBookingsStateOptions: any[] = [];

  TillAccess: boolean = false;
  TillAccessStateOptions: any[] = [];
  TillName: string = '';
  TerminalName: string = '';
  GeneralTerminalName: string = '';
  StripeTerminals: { label: string; value: string }[] = [];
  selectedTerminal: { label: string; value: string } | null = null;
  selectedGeneralTerminal: { label: string; value: string } | null = null;
  readonly deviceLocalKeys = ['TerminalName', 'GeneralTerminalName', 'TillName'];

  PBWStyleStateOptions: any[] = [];

  selectedCancelledBookingEmailTemplate: any;

  IgnoreDateRestrictionsStateOptions: any[] = [];
  IgnoreDateRestrictions: boolean = false;

  ShowSummaryAtBottomOnDesktop: boolean = false;
  ShowAtAGlanceFigures: boolean = true;
  ShowGoogleReview: boolean = true;
  ShowNewBookingsOnAtAGlance: boolean = false;
  GoogleReviewId: string = 'CYnsY6YIu4D-EAE';
  notesonpbw: boolean = false;
  //Left empty on purpose. Empty means "use the wording the wizard ships with", which is what
  //the input's placeholder shows, so a venue only stores a value once it wants its own.
  PublicBookingWizardNotesText: string = '';
  AllowResourcesChangedManually: boolean = false;
  ReturnResourceSpaceOnCustomerLeaving: boolean = false;

  cultures: any[] = [];
  chosenCulture: any;

  betaemailing: boolean = false;
  betatask: boolean = false;
  betamembership: boolean = false;

   WebhookURL: string = "";

   NoAvailabilityMessage: string = "There are no times available that match your criteria";

   WaiversActive: boolean = false;
   CustomerPortalActive: boolean = false;
   CustomerPortalMinPayment: number = 0;
   ConfirmNumberMessage: string = '';
   pendingAction: string = '';
   waiverminage: number = 18;
   waiverminageparticipate: number = 0;

   SimRacingEnabled: boolean = false;
   SimRacingAPIKey: string = "";
   SimRacingVenueID: string = "";
   BrevoEnabled: boolean = false;
   BrevoAPIKey: string = "";
   MailChimpEnabled: boolean = false;
   MailChimpAPIKey: string = "";

   ogTitle: string = "";
   ogDescription: string = "";
   ogUrl: string = "";
   ogImage: string = "";
   ogImageGuid: string = uuidv4();
   ogImageMode: 'url' | 'upload' = 'url';

   ogImageModeOptions = [
     { label: 'Enter URL', value: 'url' },
     { label: 'Upload Image', value: 'upload' },
   ];

   get currencySymbol(): string {
     const code = this.chosenCurrency ?? localStorage.getItem("Currency") ?? "GBP";
     if (code === "USD") return "$";
     if (code === "EUR") return "€";
     if (code === "AUD") return "$";
     return "£";
   }

   HTMLbmxurl: string = bmxurl;

   HomePageList: {value: string, name: string}[] = [
    {value: "home", name: "Bookings Created Today"},
    {value: "ataglance", name: "At A Glance"},
    {value: "bookinglist", name: "Booking List"},
    {value: "daysheetstyle1", name: "Day Sheet"},
   ];

   ChosenHomePage: any = {value: "home", name: "Bookings Created Today"};

   WaiverAgeList = [
    {name: "13 Years", value: 13}
    ,{name: "14 Years", value: 14}
    ,{name: "15 Years", value: 15}
    ,{name: "16 Years", value: 16}
    ,{name: "17 Years", value: 17}
    ,{name: "18 Years", value: 18}
   ];

   WaiverAgeList2 = [
     {name: "0 Years", value: 0}
    ,{name: "1 Year", value: 1}
    ,{name: "2 Years", value: 2}
    ,{name: "3 Years", value: 3}
    ,{name: "4 Years", value: 4}
    ,{name: "5 Years", value: 5}
    ,{name: "6 Years", value: 6}
    ,{name: "7 Years", value: 7}
    ,{name: "8 Years", value: 8}
    ,{name: "9 Years", value: 9}
    ,{name: "10 Years", value: 10}
    ,{name: "11 Years", value: 11}
    ,{name: "12 Years", value: 12}
    ,{name: "13 Years", value: 13}
    ,{name: "14 Years", value: 14}
    ,{name: "15 Years", value: 15}
    ,{name: "16 Years", value: 16}
    ,{name: "17 Years", value: 17}
    ,{name: "18 Years and over", value: 18}
   ];
  
  MinWaiverAge: any = {name: "18 Years", value: 18}

  WaiverMinAgeParticipate: any = {name: "0 Years", value: 0}

  constructor(private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private globalService: GlobalService) {

    this.getVenueSettings();
    this.loadStripeTerminals();

    this.diagnosticsModeStateOptions = [{label: 'Off', value: false}, {label: 'On', value: true}];
    this.minimalDetailsStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.includeParticipants = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.ConfirmationsStateOptions = [{label: 'Email', value: 'Email'}, {label: 'SMS', value: 'SMS'}, {label: 'Both', value: 'Both'}, {label: 'None', value: 'None'}];
    this.paymentAmountStateOptions = [{label: 'Deposit', value: 'DEPOSIT'}, {label: 'Full Payment', value: 'FULL'}];
    this.delayBookingStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.intinerarySummaryStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.PBWStyleStateOptions = [{label: 'Date First', value: "DATEFIRST"}, {label: 'Package First', value: "PACKAGEFIRST"}];
    this.IgnoreDateRestrictionsStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.BNStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.StopPublicBookingsStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];
    this.TillAccessStateOptions = [{label: 'No', value: false}, {label: 'Yes', value: true}];

    this.Currencies = [
      {name: 'GBP (£)', code: 'GBP'},
      {name: 'USD ($)', code: 'USD'},
      {name: 'EUR (€)', code: 'EUR'},
      {name: 'AUD ($)', code: 'AUD'},
    ]

    this.timezones = [
      { name: "(GMT -12:00) Eniwetok, Kwajalein", value: "-12:00"},
      { name: "(GMT -11:00) Midway Island, Samoa", value: "-11:00"},
      { name: "(GMT -10:00) Hawaii", value: "-10:00"},
      { name: "(GMT -9:30) Taiohae", value: "-09:50"},
      { name: "(GMT -9:00) Alaska", value: "-09:00"},
      { name: "(GMT -8:00) Pacific Time (US &amp; Canada)", value: "-08:00"},
      { name: "(GMT -7:00) Mountain Time (US &amp; Canada)", value: "-07:00"},
      { name: "(GMT -6:00) Central Time (US &amp; Canada), Mexico City", value: "-06:00"},
      { name: "(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima", value: "-05:00"},
      { name: "(GMT -4:30) Caracas", value: "-04:50"},
      { name: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz", value: "-04:00"},
      { name: "(GMT -3:30) Newfoundland", value: "-03:50"},
      { name: "(GMT -3:00) Brazil, Buenos Aires, Georgetown", value: "-03:00"},
      { name: "(GMT -2:00) Mid-Atlantic", value: "-02:00"},
      { name: "(GMT -1:00) Azores, Cape Verde Islands", value: "-01:00"},
      { name: "(GMT) Western Europe Time, London, Lisbon, Casablanca", value: "+00:00"},
      { name: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris", value: "+01:00"},
      { name: "(GMT +2:00) Kaliningrad, South Africa", value: "+02:00"},
      { name: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg", value: "+03:00"},
      { name: "(GMT +3:30) Tehran", value: "+03:50"},
      { name: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi", value: "+04:00"},
      { name: "(GMT +4:30) Kabul", value: "+04:50"},
      { name: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent", value: "+05:00"},
      { name: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi", value: "+05:50"},
      { name: "(GMT +5:45) Kathmandu, Pokhara", value: "+05:75"},
      { name: "(GMT +6:00) Almaty, Dhaka, Colombo", value: "+06:00"},
      { name: "(GMT +6:30) Yangon, Mandalay", value: "+06:50"},
      { name: "(GMT +7:00) Bangkok, Hanoi, Jakarta", value: "+07:00"},
      { name: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong", value: "+08:00"},
      { name: "(GMT +8:45) Eucla", value: "+08:75"},
      { name: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk", value: "+09:00"},
      { name: "(GMT +9:30) Adelaide, Darwin", value: "+09:50"},
      { name: "(GMT +10:00) Eastern Australia, Guam, Vladivostok", value: "+10:00"},
      { name: "(GMT +10:30) Lord Howe Island", value: "+10:50"},
      { name: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia", value: "+11:00"},
      { name: "(GMT +11:30) Norfolk Island", value: "+11:50"},
      { name: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka", value: "+12:00"},
      { name: "(GMT +12:45) Chatham Islands", value: "+12:75"},
      { name: "(GMT +13:00) Apia, Nukualofa", value: "+13:00"},
      { name: "(GMT +14:00) Line Islands, Tokelau", value: "+14:00"}
    ];

    this.cultures = [
      {name: 'English', code: 'en-GB'},
      {name: 'French', code: 'fr-FR'},
      {name: 'German', code: 'de-DE'},
      {name: 'Spanish', code: 'es-ES'}
    ];

    this.venueStartTimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];
   
    this.venueStartTimeMins = [
        {name: '00', code: '00'},
        {name: '05', code: '05'},
        {name: '10', code: '10'},
        {name: '15', code: '15'},
        {name: '20', code: '20'},
        {name: '25', code: '25'},
        {name: '30', code: '30'},
        {name: '35', code: '35'},
        {name: '40', code: '40'},
        {name: '45', code: '45'},
        {name: '50', code: '50'},
        {name: '55', code: '55'},
      ];

    this.venueMondayStartTimeHours = [];

    this.venueMondayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueTuesdayStartTimeHours = [];

    this.venueTuesdayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueWednesdayStartTimeHours = [];

    this.venueWednesdayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueThursdayStartTimeHours = [];

    this.venueThursdayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueFridayStartTimeHours = [];

    this.venueFridayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueSaturdayStartTimeHours = [];

    this.venueSaturdayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueSundayStartTimeHours = [];

    this.venueSundayStartTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.venueEndTimeHours = [
      {name: '00', code: '00'},
      {name: '01', code: '01'},
      {name: '02', code: '02'},
      {name: '03', code: '03'},
      {name: '04', code: '04'},
      {name: '05', code: '05'},
      {name: '06', code: '06'},
      {name: '07', code: '07'},
      {name: '08', code: '08'},
      {name: '09', code: '09'},
      {name: '10', code: '10'},
      {name: '11', code: '11'},
      {name: '12', code: '12'},
      {name: '13', code: '13'},
      {name: '14', code: '14'},
      {name: '15', code: '15'},
      {name: '16', code: '16'},
      {name: '17', code: '17'},
      {name: '18', code: '18'},
      {name: '19', code: '19'},
      {name: '20', code: '20'},
      {name: '21', code: '21'},
      {name: '22', code: '22'},
      {name: '23', code: '23'}
      ];

    this.venueEndTimeMins = [
      {name: '00', code: '00'},
      {name: '05', code: '05'},
      {name: '10', code: '10'},
      {name: '15', code: '15'},
      {name: '20', code: '20'},
      {name: '25', code: '25'},
      {name: '30', code: '30'},
      {name: '35', code: '35'},
      {name: '40', code: '40'},
      {name: '45', code: '45'},
      {name: '50', code: '50'},
      {name: '55', code: '55'}
    ];

    this.mondaySelectedTimes = [
    ];

    this.mondayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.tuesdayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.wednesdayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.thursdayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.fridayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.saturdayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.sundayTemplate = [
      {templatename: 'Every 5 minutes', time: '5'},
      {templatename: 'Every 10 minutes', time: '10'},
      {templatename: 'Every 15 minutes', time: '15'},
      {templatename: 'Every 20 minutes', time: '20'},
      {templatename: 'Every 30 minutes', time: '30'},
      {templatename: 'Every 60 minutes', time: '60'},
      {templatename: 'Every 120 minutes', time: '120'}
    ];

    this.venuesettings = {
      id: null,
      venueid: this.VenueID,
      venuesettings: []
    }

    
  }

  getTimeIndex(time:string)
  {
    return this.alltimes.indexOf(time);
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params['action']) {
        this.pendingAction = params['action'];
      }

      //?tab=settings comes from the cog on the top bar. Tab indexes are positional and the
      //commented-out Venue Start Times panel does not count, so Settings is 1.
      if (params['tab'] === 'settings') {
        this.activeTabIndex = 1;
      }

      if (params['action'] || params['tab']) {
        this.router.navigate([], { queryParams: {}, replaceUrl: true });
      }
    });

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("VENUESETTINGS", user)){
          this.AccessAllowed = true;
          //read individual venue settings from localStorage
          this.vsDiagnostics = localStorage.getItem("AvailabilityDiagnostics") == "true" ? true : false;
          this.vsPBWStyle = localStorage.getItem("PBWStyle") == null ? "DATEFIRST" : localStorage.getItem("PBWStyle");
          this.BNemail = localStorage.getItem("BookingNotificationEmail");
          this.BookingNotification = localStorage.getItem("BookingNotification") == "true" ? true : false;
          this.StopPublicBookings = localStorage.getItem("StopPublicBookings") == "true" ? true : false;
          this.vsGTMCode =  localStorage.getItem("GTMCode");
          this.vsConfirmations = localStorage.getItem("EMailSMSConfirmation");
          this.defInterval = Number(localStorage.getItem("DefaultInterval"));
          this.idleTimeout = Number(localStorage.getItem("idleTimeout"));
          this.AllowTimeOut =  localStorage.getItem("AllowTimeOut") == "true" ? true : false;
          this.CustomerServiceEmail = localStorage.getItem("CustomerServiceEmail") ?? "";
          this.CustomerServicePhone = localStorage.getItem("CustomerServicePhone") ?? "";
          this.UseCounters = localStorage.getItem("UseCounters") == "true" ? true : false;
          this.SummaryItinerary = localStorage.getItem("SummaryItinerary") == "true" ? true : false;
          this.SummaryItineraryVenue = localStorage.getItem("SummaryItineraryVenue") == "true" ? true : false;
          this.IgnoreDateRestrictions = localStorage.getItem("IgnoreDateRestrictions") == "true" ? true : false;
          this.ShowSummaryAtBottomOnDesktop = localStorage.getItem("ShowSummaryAtBottomOnDesktop") == "true" ? true : false;
          this.ShowAtAGlanceFigures = localStorage.getItem("ShowAtAGlanceFigures") != "false";
          this.ShowGoogleReview = localStorage.getItem("ShowGoogleReview") != "false";
          this.ShowNewBookingsOnAtAGlance = localStorage.getItem("ShowNewBookingsOnAtAGlance") == "true";
          this.GoogleReviewId = localStorage.getItem("GoogleReviewId") == null ? 'CYnsY6YIu4D-EAE' : localStorage.getItem("GoogleReviewId");
          this.notesonpbw = localStorage.getItem("notesonpbw") == "true" ? true : false;
          this.PublicBookingWizardNotesText = localStorage.getItem("PublicBookingWizardNotesText") ?? '';
          this.AllowResourcesChangedManually = localStorage.getItem("AllowResourcesChangedManually") == "true" ? true : false;
          this.ReturnResourceSpaceOnCustomerLeaving = localStorage.getItem("ReturnResourceSpaceOnCustomerLeaving") == "true" ? true : false;
          const rawImageURL = localStorage.getItem("PublicImgURL");
          this.vsImageURL = (rawImageURL === "null" || rawImageURL === null) ? "" : rawImageURL;
          const rawImageReturnURL = localStorage.getItem("ImageReturnURL");
          this.vsImageReturnURL = (rawImageReturnURL === null || rawImageReturnURL === "null") ? "" : rawImageReturnURL;
          this.vsImageMode = (localStorage.getItem("PublicImgMode") as 'url' | 'upload') ?? 'url';
          this.vsImageGuid = localStorage.getItem("PublicImgGuid") ?? uuidv4();
          this.imageWidth =  Number(localStorage.getItem("PublicImageWidth"));
          this.imageHeight =  Number(localStorage.getItem("PublicImageheight"));
          this.defaultColour =  localStorage.getItem("DefaultColour");
          this.defaultBackgroundColour = localStorage.getItem("DefaultBackgroundVColour");
          this.defaultTextColour = localStorage.getItem("DefaultTextColour") ?? "#000000";
          this.defaultButtonTextColour = localStorage.getItem("DefaultButtonTextColour") ?? "#ffffff";
          this.defaultSummaryBackgroundColour = localStorage.getItem("DefaultSummaryBackgroundColour") ?? "#ffffff";
          this.defaultSummaryHeaderFooterColour = localStorage.getItem("DefaultSummaryHeaderFooterColour") ?? "#5974af";
          this.defaultSummaryHeaderFooterTextColour = localStorage.getItem("DefaultSummaryHeaderFooterTextColour") ?? "#ffffff";
          this.defaultSummaryTextColour = localStorage.getItem("DefaultSummaryTextColour") ?? "#000000";
          this.RyftSubAccountID =  localStorage.getItem("RyftSubAccountID");
          this.GoogleTagManagerID =  localStorage.getItem("GoogleTagManagerID");
          this.returnPage =  localStorage.getItem("returnPage");
          this.WebhookURL = localStorage.getItem("WebHookURL");
          this.NoAvailabilityMessage = localStorage.getItem("NoAvailabilityMessage") == null ? "There are no times available that match your criteria" : localStorage.getItem("NoAvailabilityMessage");
          this.chosenTimezone =  localStorage.getItem("TimeZone");
          this.chosenCurrency =  localStorage.getItem("Currency");
          this.chosenCulture = localStorage.getItem("Culture");
          this.BookingsCannotBeMadeWithinXMinutes = Number(localStorage.getItem("BookingsCannotBeMadeWithinXMinutes"));
          this.BookingsCannotBeMadeAfterXMinutes = Number(localStorage.getItem("BookingsCannotBeMadeAfterXMinutes"));
          this.CannotMakeBookingsToday = localStorage.getItem("CannotMakeBookingsToday") == "true" ? true : false;
          this.WaiversActive = localStorage.getItem("WaiverActive") == "true" ? true : false;
          this.CustomerPortalActive = localStorage.getItem("CustomerPortalActive") == "true" ? true : false;
          this.betaemailing = localStorage.getItem("BetaEmailing") == "true" ? true : false;
          this.betatask = localStorage.getItem("BetaTask") == "true" ? true : false;
          this.betamembership = localStorage.getItem("Betamembership") == "true" ? true : false;
          this.TillAccess = localStorage.getItem("TillAccess") == "true" ? true : false;
          this.TillName = localStorage.getItem(`TillName_${this.VenueID}`) ?? '';
          this.TerminalName = localStorage.getItem(`TerminalName_${this.VenueID}`) ?? '';
          this.selectedTerminal = this.StripeTerminals.find(t => t.value === this.TerminalName) ?? null;
          this.GeneralTerminalName = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
          this.selectedGeneralTerminal = this.StripeTerminals.find(t => t.value === this.GeneralTerminalName) ?? null;
          let PLTempCode = localStorage.getItem("PaymentLinkEmailTemplate");
          let LSChosenHomePage = localStorage.getItem("ChosenHomePage");
          let VTempCode = localStorage.getItem("VoucherEmailTemplate");
          let CBTempCode = localStorage.getItem("CancelledBookingTemplate");
          this.VoucherValidity = localStorage.getItem("vouchervalidity") == null ? 12 : Number(localStorage.getItem("vouchervalidity"));
          this.MinWaiverAge = localStorage.getItem("WaiverMinAge") == null ? this.WaiverAgeList.find(x => x.value == 18) : this.WaiverAgeList.find(x => x.value == Number(localStorage.getItem("WaiverMinAge")));
          this.WaiverMinAgeParticipate = localStorage.getItem("MinWaiverAgeParticipate") == null ? this.WaiverAgeList2.find(x => x.value == 0) : this.WaiverAgeList2.find(x => x.value == Number(localStorage.getItem("MinWaiverAgeParticipate")));
          this.SimRacingEnabled = localStorage.getItem("simracing_enabled") == "true" ? true : false;
          this.SimRacingAPIKey = localStorage.getItem("simracing_apikey") ?? "";
          this.SimRacingVenueID = localStorage.getItem("simracing_venueid") ?? "";
          this.BrevoEnabled = localStorage.getItem("brevo_enabled") == "true" ? true : false;
          this.BrevoAPIKey = localStorage.getItem("brevo_apikey") ?? "";
          this.MailChimpEnabled = localStorage.getItem("mailchimp_enabled") == "true" ? true : false;
          this.MailChimpAPIKey = localStorage.getItem("mailchimp_apikey") ?? "";
          this.ogTitle = localStorage.getItem("og_title") ?? "";
          this.ogDescription = localStorage.getItem("og_description") ?? "";
          this.ogUrl = localStorage.getItem("og_url") ?? "";
          this.ogImage = localStorage.getItem("og_image") ?? "";
          this.ogImageGuid = localStorage.getItem("og_image_guid") ?? uuidv4();
          this.ogImageMode = (localStorage.getItem("og_image_mode") as 'url' | 'upload') ?? 'url';

          if (this.pendingAction === 'activate-waivers') {
            this.WaiversActive = true;
            this.pendingAction = '';
            this.updateSettingsData(false);
          } else if (this.pendingAction === 'activate-customerportal') {
            this.CustomerPortalActive = true;
            this.pendingAction = '';
            this.updateSettingsData(false);
          }

          this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
            this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.EmailTemplates = (response as emailtemplate_returndata).data;

              if(LSChosenHomePage != null)
              {
                this.ChosenHomePage = this.HomePageList.find(x => x.value == LSChosenHomePage);
              }

              if(PLTempCode != null)
              {
                this.selectedPaymentLinkEmailTemplate = this.EmailTemplates.find(x => x.emailtemplateid == PLTempCode);
              }

              if(VTempCode != null)
              {
                this.selectedVoucherEmailTemplate = this.EmailTemplates.find(x => x.emailtemplateid == VTempCode);
              }

              if(CBTempCode != null)
              {
                this.selectedCancelledBookingEmailTemplate = this.EmailTemplates.find(x => x.emailtemplateid == CBTempCode);
              }
            }
            else
            {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
          });
          
          this.PaymentAmountSelection = localStorage.getItem("PaymentAmountSelection");
      
      this.http.get(bmxurl + "venue/" + this.VenueID).subscribe(response => {
        this.Venue = (response as venue_returndata);
        
        this.DoTimes(this.Venue.data);
        
        this.VCapacityIncludesParticipant = this.Venue.data.VCapacityIncludesParticipant;
      //build times
      this.buildTimes();

      
      this.http.get(bmxurl + "VenueStartTimes/" + this.VenueID).subscribe(response => {
        this.venueStartTimes = (response as venuestarttimes_returndata);

        if(this.venueStartTimes.data.id != null)
        {
          this.VenueStartTimeSetID = this.venueStartTimes.data.id;
          
          this.mondaySelectedTimes = this.venueStartTimes.data.mondaytimes;
          this.tuesdaySelectedTimes = this.venueStartTimes.data.tuesdaytimes;
          this.wednesdaySelectedTimes = this.venueStartTimes.data.wednesdaytimes;
          this.thursdaySelectedTimes = this.venueStartTimes.data.thursdaytimes;
          this.fridaySelectedTimes = this.venueStartTimes.data.fridaytimes;
          this.saturdaySelectedTimes = this.venueStartTimes.data.saturdaytimes;
          this.sundaySelectedTimes = this.venueStartTimes.data.sundaytimes;
        }
        else
        {
          this.VenueStartTimeSetID = this.venueStartTimes.data.id;
          
          this.mondaySelectedTimes = [];
          this.tuesdaySelectedTimes = [];
          this.wednesdaySelectedTimes = [];
          this.thursdaySelectedTimes = [];
          this.fridaySelectedTimes = [];
          this.saturdaySelectedTimes = [];
          this.sundaySelectedTimes = [];

          //this.messageService.add({ severity: 'warn', summary: 'No Start Times', detail: 'There are no start times, please create some.' });
        }
      
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.messages[0] });
      });

      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.messages[0] });
      });
        }

        this.CompletedLoading = true;
        
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

    this.http.get(bmxurl + "/venuehost/" + this.VenueID).subscribe(response => {
      this.httpResponse =  (response as host_returndata);

          if((response as host_returndata).succeeded)
          {
            this.PublicHostName = "https://wannabook.online/booking/" + (response as host_returndata).data.hostname;
            this.PublicHostNameVoucher = "https://wannabook.online/buyvoucher/" + (response as host_returndata).data.hostname;
            this.PublicHostNameMembership = "https://wannabook.online/buymembership/" + (response as host_returndata).data.hostname;
            this.PublicHostNameScheduledSession = "https://wannabook.online/buymembership/" + (response as host_returndata).data.hostname + "?SS=true";
            this.PublicHostNameEvents = "https://wannabook.online/events/" + (response as host_returndata).data.hostname;
            this.PublicWaiverForGroup = "https://wannabook.online/completewaiver/" + (response as host_returndata).data.hostname + "/true/qr";
          }
    });

  }

  getVenueSettings()
  {
      this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse =  (response as venuesettings_returndata)
      if(this.httpResponse.succeeded)
      {
        //Set Venue Settings ID
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          if (this.deviceLocalKeys.includes(element.name)) return;
          localStorage.removeItem(element.name);
          localStorage.setItem(element.name, element.value);

          if (element.name == "WaiverActive") {
            this.WaiversActive = element.value == "true" ? true : false;
          }
          if (element.name == "CustomerPortalActive") {
            this.CustomerPortalActive = element.value == "true" ? true : false;
          }
          if (element.name == "CustomerPortalMinPayment") {
            this.CustomerPortalMinPayment = parseFloat(element.value) || 0;
          }
          if (element.name == "confirmmessage") {
            this.ConfirmNumberMessage = element.value ?? '';
          }
          if (element.name == "simracing_enabled") {
            this.SimRacingEnabled = element.value == "true" ? true : false;
          }
          if (element.name == "simracing_apikey") {
            this.SimRacingAPIKey = element.value == null ? "" : element.value;
          }
          if (element.name == "simracing_venueid") {
            this.SimRacingVenueID = element.value == null ? "" : element.value;
          }
          if (element.name == "brevo_enabled") {
            this.BrevoEnabled = element.value == "true" ? true : false;
          }
          if (element.name == "brevo_apikey") {
            this.BrevoAPIKey = element.value == null ? "" : element.value;
          }
          if (element.name == "mailchimp_enabled") {
            this.MailChimpEnabled = element.value == "true" ? true : false;
          }
          if (element.name == "mailchimp_apikey") {
            this.MailChimpAPIKey = element.value == null ? "" : element.value;
          }
        });

        //Settings the venue has never saved are absent from the response, so clear any
        //stale localStorage value left behind by another venue and fall back to the default.
        const notesOnPBW = this.httpResponse.data.venueSettings.find(vs => vs.name == "notesonpbw");
        if (notesOnPBW == null) {
          localStorage.removeItem("notesonpbw");
        }
        this.notesonpbw = notesOnPBW != null && notesOnPBW.value == "true";
      }
      else{
        this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
    });
  }

  loadStripeTerminals(): void {
    this.http.get(bmxurl + 'StripeTerminalList/' + this.VenueID).subscribe({
      next: (response: any) => {
        const raw = response?.data ?? response;
        const list: any[] = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        this.StripeTerminals = list
          .filter((t: any) => t?.id)
          .map((t: any) => ({ label: t.label ?? t.id, value: t.id }));
        this.selectedTerminal = this.StripeTerminals.find(t => t.value === this.TerminalName) ?? null;
        this.selectedGeneralTerminal = this.StripeTerminals.find(t => t.value === this.GeneralTerminalName) ?? null;
      },
      error: (err) => { console.error('StripeTerminalList error:', err); }
    });
  }

  onTerminalChange(event: any): void {
    this.selectedTerminal = event.value;
  }

  onGeneralTerminalChange(event: any): void {
    this.selectedGeneralTerminal = event.value;
    this.GeneralTerminalName = event.value?.value ?? '';
  }

  ensureHttpPrefix(field: 'vsImageReturnURL' | 'returnPage') {
    const val = this[field]?.trim();
    if (val && !val.startsWith('http://') && !val.startsWith('https://')) {
      this[field] = 'https://' + val;
    }
  }

  copyData(link: string) {
    navigator.clipboard.writeText(link).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Link copied to clipboard' });
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy link' });
    });
  }

  private buildTimes() {
    let iStartTime = Number(this.venueStartTime.substring(0, 2));
    let iEndTime = Number(this.venueEndTime.substring(0, 2));

    for (let i = iStartTime; i <= iEndTime; i++) {
      let thisTime = {
        name: ("00" + i).slice(-2),
        code: ("00" + i).slice(-2)
      };
      this.venueMondayStartTimeHours.push(thisTime);
      this.venueTuesdayStartTimeHours.push(thisTime);
      this.venueWednesdayStartTimeHours.push(thisTime);
      this.venueThursdayStartTimeHours.push(thisTime);
      this.venueFridayStartTimeHours.push(thisTime);
      this.venueSaturdayStartTimeHours.push(thisTime);
      this.venueSundayStartTimeHours.push(thisTime);
    }
  }

  DoTimes(inData:any) {
    this.venueStartTime = inData.startTime;
    this.venueEndTime = inData.endTime;

    this.startTimeIndex = this.alltimes.indexOf(this.venueStartTime);
    this.endTimeIndex = this.alltimes.indexOf(this.venueEndTime);

    //Get Venue start time index
    this.venuestarttimeindex = this.getTimeIndex(inData.startTime);
    this.venueendtimeindex = this.getTimeIndex(inData.endTime);

    this.venueSelectedStartTimeHours = this.venueStartTime.substring(0, 2);
    this.venueSelectedStartTimeMins = this.venueStartTime.substring(3);

    this.venueSelectedEndTimeHours = this.venueEndTime.substring(0, 2);
    this.venueSelectedEndTimeMins = this.venueEndTime.substring(3);
  }

  ClearTimesMonday(){
    this.mondaySelectedTimes = [];
  }

  ClearTimesTuesday(){
    this.tuesdaySelectedTimes = [];
  }

  ClearTimesWednesday(){
    this.wednesdaySelectedTimes = [];
  }

  ClearTimesThursday(){
    this.thursdaySelectedTimes = [];
  }

  ClearTimesFriday(){
    this.fridaySelectedTimes = [];
  }

  ClearTimesSaturday(){
    this.saturdaySelectedTimes = [];
  }

  ClearTimesSunday(){
    this.sundaySelectedTimes = [];
  }

  updateData()
  {
    if(this.DoValidCheck(true))
    {
      this.Venue.data.startTime = this.venueSelectedStartTimeHours + ":" + this.venueSelectedStartTimeMins;
      this.Venue.data.endTime = this.venueSelectedEndTimeHours + ":" + this.venueSelectedEndTimeMins;
      this.Venue.data.VCapacityIncludesParticipant = this.VCapacityIncludesParticipant;

      this.Venue.data.prefix = this.Venue.data.prefix.trim();

      this.http.put<venue>(bmxurl + "/venue", this.Venue.data).subscribe(response => {
        this.VenueReturnData = response
        if(this.VenueReturnData.succeeded) {
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Venue Details saved' });
          this.globalService.setVenueName (this.Venue.data.Name);
          this.DoTimes(this.VenueReturnData.data);

          //The customer services details sit on this tab but are venue settings rather than part
          //of the venue record, so saving here has to save those too. Quietly - the venue save
          //has already said so.
          this.updateSettingsData(false);

          this.buildTimes();
        }
      }, error => {
        this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages[0] });
      })
    }
  }

  updateStartTimeData()
  {
    this.venueStartTimes = {
      id: this.VenueStartTimeSetID,
      venueid: this.VenueID,
      disabled: false,
      mondaytimes: this.mondaySelectedTimes,
      tuesdaytimes: this.tuesdaySelectedTimes,
      wednesdaytimes: this.wednesdaySelectedTimes,
      thursdaytimes: this.thursdaySelectedTimes,
      fridaytimes: this.fridaySelectedTimes,
      saturdaytimes: this.saturdaySelectedTimes,
      sundaytimes: this.sundaySelectedTimes,
    }
    
    
    if(this.VenueStartTimeSetID == null)
    {
      this.http.post<venuestarttimes>(bmxurl + "/venuestarttimes", this.venueStartTimes).subscribe(response => {
          this.messageService.add({severity:'success', summary:'Saved', detail:'Start Times successfully created'});
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
      })
    }
    else
    {
      this.http.put<venuestarttimes>(bmxurl + "/venuestarttimes", this.venueStartTimes).subscribe(response => {
        this.messageService.add({severity:'success', summary:'Saved', detail:'Start Times successfully created'});
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages[0]});
    })
    }

  }

  uploadedVsImage(event: any) {
    this.vsImageURL = event.originalEvent.body.data;
  }

  removeVsImage() {
    this.vsImageURL = "";
  }

  uploadedOgImage(event: any) {
    this.ogImage = event.originalEvent.body.data;
  }

  removeOgImage() {
    this.ogImage = "";
  }

  activateWaivers(){
    this.router.navigate(['/agreement/WAIVERAGREEMENT'], { queryParams: { returnAction: 'activate-waivers' } });
  }

  deactivateWaivers(){
    this.WaiversActive = false;
    this.updateSettingsData(false);
  }

  activateCustomerPortal(){
    this.router.navigate(['/agreement/CUSTOMERPORTALAGREEMENT'], { queryParams: { returnAction: 'activate-customerportal' } });
  }

  deactivateCustomerPortal(){
    this.CustomerPortalActive = false;
    this.updateSettingsData(false);
  }

  RemoveMondayChip(item)
  {
    this.mondaySelectedTimes = this.mondaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveTuesdayChip(item)
  {
    this.tuesdaySelectedTimes = this.tuesdaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveWednesdayChip(item)
  {
    this.wednesdaySelectedTimes = this.wednesdaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveThursdayChip(item)
  {
    this.thursdaySelectedTimes = this.thursdaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveFridayChip(item)
  {
    this.fridaySelectedTimes = this.fridaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveSaturdayChip(item)
  {
    this.saturdaySelectedTimes = this.saturdaySelectedTimes.filter(obj => obj.time !== item);
  }

  RemoveSundayChip(item)
  {
    this.sundaySelectedTimes = this.sundaySelectedTimes.filter(obj => obj.time !== item);
  }

  addTemplatedMonday()
  {
     let interval:number = Number(this.mondaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.mondaySelectedTimes == null)
        this.mondaySelectedTimes = [];

      if(this.mondaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.mondaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.mondaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.mondaySelectedTimes = sortedArray;

     }
  }

  addTemplatedTuesday()
  {
     let interval:number = Number(this.tuesdaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.tuesdaySelectedTimes == null)
        this.tuesdaySelectedTimes = [];

      if(this.tuesdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.tuesdaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.tuesdaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.tuesdaySelectedTimes = sortedArray;

     }
  }

  addTemplatedWednesday()
  {
     let interval:number = Number(this.wednesdaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.wednesdaySelectedTimes == null)
        this.wednesdaySelectedTimes = [];

      if(this.wednesdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.wednesdaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.wednesdaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.wednesdaySelectedTimes = sortedArray;

     }
  }

  addTemplatedThursday()
  {
     let interval:number = Number(this.thursdaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.thursdaySelectedTimes == null)
        this.thursdaySelectedTimes = [];

      if(this.thursdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.thursdaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.thursdaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.thursdaySelectedTimes = sortedArray;

     }
  }

  addTemplatedFriday()
  {
     let interval:number = Number(this.fridaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.fridaySelectedTimes == null)
        this.fridaySelectedTimes = [];

      if(this.fridaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.fridaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.fridaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.fridaySelectedTimes = sortedArray;

     }
  }

  addTemplatedSaturday()
  {
     let interval:number = Number(this.saturdaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.saturdaySelectedTimes == null)
        this.saturdaySelectedTimes = [];

      if(this.saturdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.saturdaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.saturdaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.saturdaySelectedTimes = sortedArray;

     }
  }

  addTemplatedSunday()
  {
     let interval:number = Number(this.sundaySelectedTemplate);

     let startIndex = this.alltimes.indexOf(this.venueStartTime);
     let endIndex = this.alltimes.indexOf(this.venueEndTime);

     for(var i = startIndex; i < endIndex; i = i + interval)
     {
      let thisTime = {
        index: i,
        time: this.alltimes[i]
      }

      if(this.sundaySelectedTimes == null)
        this.sundaySelectedTimes = [];

      if(this.sundaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.sundaySelectedTimes.push(thisTime);
      }
      
    
    var sortedArray: time[] =  this.sundaySelectedTimes.sort((n1,n2) => {
        if (n1.index > n2.index) {
            return 1;
        }
    
        if (n1.index < n2.index) {
            return -1;
        }
    });
    
    this.sundaySelectedTimes = sortedArray;

     }
  }

  addAdHocMonday()
  {
    
    let hours = this.venueMondaySelectedStartTimeHours;
    let mins = this.venueMondaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);

    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.mondaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.mondaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.mondaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.mondaySelectedTimes = sortedArray;
    }
  }

  addAdHocTuesday()
  {
    
    let hours = this.venueTuesdaySelectedStartTimeHours;
    let mins = this.venueTuesdaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.tuesdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.tuesdaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.tuesdaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.tuesdaySelectedTimes = sortedArray;
    }
  }

  addAdHocWednesday()
  {
    
    let hours = this.venueWednesdaySelectedStartTimeHours;
    let mins = this.venueWednesdaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.wednesdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.wednesdaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.wednesdaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.wednesdaySelectedTimes = sortedArray;
    }
  }

  addAdHocThursday()
  {
    
    let hours = this.venueThursdaySelectedStartTimeHours;
    let mins = this.venueThursdaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.thursdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.thursdaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.thursdaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.thursdaySelectedTimes = sortedArray;
    }
  }

  addAdHocFriday()
  {
    
    let hours = this.venueFridaySelectedStartTimeHours;
    let mins = this.venueFridaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.fridaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.fridaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.fridaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.fridaySelectedTimes = sortedArray;
    }
  }

  addAdHocSaturday()
  {
    
    let hours = this.venueSaturdaySelectedStartTimeHours;
    let mins = this.venueSaturdaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.saturdaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.saturdaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.saturdaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.saturdaySelectedTimes = sortedArray;
    }
  }

  addAdHocSunday()
  {
    
    let hours = this.venueSundaySelectedStartTimeHours;
    let mins = this.venueSundaySelectedStartTimeMins;

    let time: any =  hours + ":" + mins;
    let adHocIndex = this.alltimes.indexOf(time);
    if(adHocIndex < this.venuestarttimeindex || adHocIndex > this.venueendtimeindex)
    {
      this.messageService.add({severity:'error', summary:'Error', detail:'The time chosen must be within the venue operating times (' + this.venueStartTime + ' - ' + this.venueEndTime +')'});
    }
    else
    {
      let thisTime = {
        index: adHocIndex,
        time: hours + ":" + mins
      };

      if(this.sundaySelectedTimes.map(e => e.index).indexOf(thisTime.index) < 0)
      {
        this.sundaySelectedTimes.push(thisTime);
      }
    
      var sortedArray: time[] =  this.sundaySelectedTimes.sort((n1,n2) => {
          if (n1.index > n2.index) {
              return 1;
          }
      
          if (n1.index < n2.index) {
              return -1;
          }
      });
      
      this.sundaySelectedTimes = sortedArray;
    }
  }
  
  returnHome()
  {
    this.router.navigateByUrl("home");
  }

  onStopPublicBookingsChange(event: any)
  {
    if(event.value === true)
    {
      this.confirmationService.confirm({
        message: 'Warning: Enabling this setting will prevent ALL public bookings from being made. Are you sure you want to stop public bookings?',
        header: 'Stop Public Bookings',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes, Stop Public Bookings',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-danger',
        accept: () => {
          this.StopPublicBookings = true;
        },
        reject: () => {
          this.StopPublicBookings = false;
        }
      });
    }
  }

  getLatLong(postcode){
    this.http.get("https://findthatpostcode.uk/postcodes/" + postcode + ".json").subscribe(response => {
      this.PostCodeAPIResult = response;
      this.Venue.data.lat = this.PostCodeAPIResult.data.attributes.lat;
      this.Venue.data.lon = this.PostCodeAPIResult.data.attributes.long;
    });
  }

  MondayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.tuesdaySelectedTimes = this.mondaySelectedTimes;
        this.wednesdaySelectedTimes = this.mondaySelectedTimes;
        this.thursdaySelectedTimes = this.mondaySelectedTimes;
        this.fridaySelectedTimes = this.mondaySelectedTimes;
        this.saturdaySelectedTimes = this.mondaySelectedTimes;
        this.sundaySelectedTimes = this.mondaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.tuesdaySelectedTimes = this.mondaySelectedTimes;
        this.wednesdaySelectedTimes = this.mondaySelectedTimes;
        this.thursdaySelectedTimes = this.mondaySelectedTimes;
        this.fridaySelectedTimes = this.mondaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.mondaySelectedTimes;
        this.sundaySelectedTimes = this.mondaySelectedTimes;
        break;
      default:
        this.tuesdaySelectedTimes = this.mondaySelectedTimes;
        this.wednesdaySelectedTimes = this.mondaySelectedTimes;
        this.thursdaySelectedTimes = this.mondaySelectedTimes;
        this.fridaySelectedTimes = this.mondaySelectedTimes;
        this.saturdaySelectedTimes = this.mondaySelectedTimes;
        this.sundaySelectedTimes = this.mondaySelectedTimes;
    }
  }

  TuesdayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.tuesdaySelectedTimes;
        this.wednesdaySelectedTimes = this.tuesdaySelectedTimes;
        this.thursdaySelectedTimes = this.tuesdaySelectedTimes;
        this.fridaySelectedTimes = this.tuesdaySelectedTimes;
        this.saturdaySelectedTimes = this.tuesdaySelectedTimes;
        this.sundaySelectedTimes = this.tuesdaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.tuesdaySelectedTimes;
        this.wednesdaySelectedTimes = this.tuesdaySelectedTimes;
        this.thursdaySelectedTimes = this.tuesdaySelectedTimes;
        this.fridaySelectedTimes = this.tuesdaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.tuesdaySelectedTimes;
        this.sundaySelectedTimes = this.tuesdaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.tuesdaySelectedTimes;
        this.wednesdaySelectedTimes = this.tuesdaySelectedTimes;
        this.thursdaySelectedTimes = this.tuesdaySelectedTimes;
        this.fridaySelectedTimes = this.tuesdaySelectedTimes;
        this.saturdaySelectedTimes = this.tuesdaySelectedTimes;
        this.sundaySelectedTimes = this.tuesdaySelectedTimes;
    }
  }

  WednesdayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.wednesdaySelectedTimes;
        this.tuesdaySelectedTimes = this.wednesdaySelectedTimes;
        this.thursdaySelectedTimes = this.wednesdaySelectedTimes;
        this.fridaySelectedTimes = this.wednesdaySelectedTimes;
        this.saturdaySelectedTimes = this.wednesdaySelectedTimes;
        this.sundaySelectedTimes = this.wednesdaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.wednesdaySelectedTimes;
        this.tuesdaySelectedTimes = this.wednesdaySelectedTimes;
        this.thursdaySelectedTimes = this.wednesdaySelectedTimes;
        this.fridaySelectedTimes = this.wednesdaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.wednesdaySelectedTimes;
        this.sundaySelectedTimes = this.wednesdaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.wednesdaySelectedTimes;
        this.tuesdaySelectedTimes = this.wednesdaySelectedTimes;
        this.thursdaySelectedTimes = this.wednesdaySelectedTimes;
        this.fridaySelectedTimes = this.wednesdaySelectedTimes;
        this.saturdaySelectedTimes = this.wednesdaySelectedTimes;
        this.sundaySelectedTimes = this.wednesdaySelectedTimes;
    }
  }

  ThursdayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.thursdaySelectedTimes;
        this.tuesdaySelectedTimes = this.thursdaySelectedTimes;
        this.wednesdaySelectedTimes = this.thursdaySelectedTimes;
        this.fridaySelectedTimes = this.thursdaySelectedTimes;
        this.saturdaySelectedTimes = this.thursdaySelectedTimes;
        this.sundaySelectedTimes = this.thursdaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.thursdaySelectedTimes;
        this.tuesdaySelectedTimes = this.thursdaySelectedTimes;
        this.wednesdaySelectedTimes = this.thursdaySelectedTimes;
        this.fridaySelectedTimes = this.thursdaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.thursdaySelectedTimes;
        this.sundaySelectedTimes = this.thursdaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.thursdaySelectedTimes;
        this.tuesdaySelectedTimes = this.thursdaySelectedTimes;
        this.wednesdaySelectedTimes = this.thursdaySelectedTimes;
        this.fridaySelectedTimes = this.thursdaySelectedTimes;
        this.saturdaySelectedTimes = this.thursdaySelectedTimes;
        this.sundaySelectedTimes = this.thursdaySelectedTimes;
    }
  }

  FridayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.fridaySelectedTimes;
        this.tuesdaySelectedTimes = this.fridaySelectedTimes;
        this.wednesdaySelectedTimes = this.fridaySelectedTimes;
        this.thursdaySelectedTimes = this.fridaySelectedTimes;
        this.saturdaySelectedTimes = this.fridaySelectedTimes;
        this.sundaySelectedTimes = this.fridaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.fridaySelectedTimes;
        this.tuesdaySelectedTimes = this.fridaySelectedTimes;
        this.wednesdaySelectedTimes = this.fridaySelectedTimes;
        this.thursdaySelectedTimes = this.fridaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.fridaySelectedTimes;
        this.sundaySelectedTimes = this.fridaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.fridaySelectedTimes;
        this.tuesdaySelectedTimes = this.fridaySelectedTimes;
        this.wednesdaySelectedTimes = this.fridaySelectedTimes;
        this.thursdaySelectedTimes = this.fridaySelectedTimes;
        this.saturdaySelectedTimes = this.fridaySelectedTimes;
        this.sundaySelectedTimes = this.fridaySelectedTimes;
    }
  }

  SaturdayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.saturdaySelectedTimes;
        this.tuesdaySelectedTimes = this.saturdaySelectedTimes;
        this.wednesdaySelectedTimes = this.saturdaySelectedTimes;
        this.thursdaySelectedTimes = this.saturdaySelectedTimes;
        this.fridaySelectedTimes = this.saturdaySelectedTimes;
        this.sundaySelectedTimes = this.saturdaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.saturdaySelectedTimes;
        this.tuesdaySelectedTimes = this.saturdaySelectedTimes;
        this.wednesdaySelectedTimes = this.saturdaySelectedTimes;
        this.thursdaySelectedTimes = this.saturdaySelectedTimes;
        this.fridaySelectedTimes = this.saturdaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.sundaySelectedTimes = this.saturdaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.saturdaySelectedTimes;
        this.tuesdaySelectedTimes = this.saturdaySelectedTimes;
        this.wednesdaySelectedTimes = this.saturdaySelectedTimes;
        this.thursdaySelectedTimes = this.saturdaySelectedTimes;
        this.fridaySelectedTimes = this.saturdaySelectedTimes;
        this.sundaySelectedTimes = this.saturdaySelectedTimes;
    }
  }

  SundayCopy(CopyType)
  {
    switch(CopyType)
    {
      case "ToWeek":
        this.mondaySelectedTimes = this.sundaySelectedTimes;
        this.tuesdaySelectedTimes = this.sundaySelectedTimes;
        this.wednesdaySelectedTimes = this.sundaySelectedTimes;
        this.thursdaySelectedTimes = this.sundaySelectedTimes;
        this.fridaySelectedTimes = this.sundaySelectedTimes;
        this.saturdaySelectedTimes = this.sundaySelectedTimes;
        break;
      case "ToWeekExcWE":
        this.mondaySelectedTimes = this.sundaySelectedTimes;
        this.tuesdaySelectedTimes = this.sundaySelectedTimes;
        this.wednesdaySelectedTimes = this.sundaySelectedTimes;
        this.thursdaySelectedTimes = this.sundaySelectedTimes;
        this.fridaySelectedTimes = this.sundaySelectedTimes;
        break;
      case "ToWeekEnd":
        this.saturdaySelectedTimes = this.sundaySelectedTimes;
        break;
      default:
        this.mondaySelectedTimes = this.sundaySelectedTimes;
        this.tuesdaySelectedTimes = this.sundaySelectedTimes;
        this.wednesdaySelectedTimes = this.sundaySelectedTimes;
        this.thursdaySelectedTimes = this.sundaySelectedTimes;
        this.fridaySelectedTimes = this.sundaySelectedTimes;
        this.saturdaySelectedTimes = this.sundaySelectedTimes;
    }
  }

  updateSettingsData(showmessage: boolean = true){

    //Availability Diagnostics
    let vsDiagnosticsContainer = new cVenuesetting;
    let vsPBWStyleContainer = new cVenuesetting;
    let vsMinimalDetailsContainer = new cVenuesetting;
    let vsImageURLContainer = new cVenuesetting;
    let vsImageReturnURLContainer = new cVenuesetting;
    let vsDefInterval = new cVenuesetting;
    let vsIdleTimeout = new cVenuesetting;
    let vsConfirmation = new cVenuesetting;
    let vsAllowTimeOut = new cVenuesetting;
    let vsCustomerServiceEmail = new cVenuesetting;
    let vsCustomerServicePhone = new cVenuesetting;
    let vsUseCounters = new cVenuesetting;
    let vsSummaryItinerary = new cVenuesetting;
    let vsSummaryItineraryVenue = new cVenuesetting;
    let vsIgnoreDateRestrictions = new cVenuesetting;
    let vsShowSummaryAtBottomOnDesktop = new cVenuesetting;
    let vsShowAtAGlanceFigures = new cVenuesetting;
    let vsShowGoogleReview = new cVenuesetting;
    let vsGoogleReviewId = new cVenuesetting;
    let vsShowNewBookingsOnAtAGlance = new cVenuesetting;
    let vsNotesOnPBW = new cVenuesetting;
    let vsPublicBookingWizardNotesText = new cVenuesetting;
    let vsAllowResourcesChangedManually = new cVenuesetting;
    let vsReturnResourceSpaceOnCustomerLeaving = new cVenuesetting;
    let vsRyftSubAccountID = new cVenuesetting;
    let vsGoogleTagManagerID = new  cVenuesetting;
    let vsReturnPage = new  cVenuesetting;
    let vsWebHookURL = new  cVenuesetting;
    let vsNoAvailabilityMessage = new  cVenuesetting;
    let vsBookingNotificationEmail = new  cVenuesetting;
    let vsBookingNotification = new  cVenuesetting;
    let vsStopPublicBookings = new  cVenuesetting;
    let vsSimRacingEnabled = new cVenuesetting;
    let vsSimRacingAPiKey = new cVenuesetting;
    let vsSimRacingVenueID = new cVenuesetting;
    let vsBrevoEnabled = new cVenuesetting;
    let vsBrevoAPIKey = new cVenuesetting;
    let vsMailChimpEnabled = new cVenuesetting;
    let vsMailChimpAPIKey = new cVenuesetting;


    vsBookingNotificationEmail.name = "BookingNotificationEmail";
    vsBookingNotificationEmail.value = this.BNemail;

    vsBookingNotification.name = "BookingNotification";
    vsBookingNotification.value = String(this.BookingNotification);

    vsStopPublicBookings.name = "StopPublicBookings";
    vsStopPublicBookings.value = String(this.StopPublicBookings);
  
    vsDiagnosticsContainer.name = "AvailabilityDiagnostics";
    vsDiagnosticsContainer.value = String(this.vsDiagnostics);

    vsPBWStyleContainer.name = "PBWStyle";
    vsPBWStyleContainer.value = String(this.vsPBWStyle);

    vsConfirmation.name = "EMailSMSConfirmation"
    vsConfirmation.value = String(this.vsConfirmations);

    vsDefInterval.name = "DefaultInterval";
    vsDefInterval.value = this.defInterval.toString();

    vsIdleTimeout.name = "idleTimeout";
    vsIdleTimeout.value = this.idleTimeout.toString();

    vsRyftSubAccountID.name = "RyftSubAccountID";
    vsRyftSubAccountID.value =  String(this.RyftSubAccountID);

    vsGoogleTagManagerID.name = "GoogleTagManagerID";
    vsGoogleTagManagerID.value =  String(this.GoogleTagManagerID);

    vsReturnPage.name = "returnPage";
    vsReturnPage.value =  String(this.returnPage);

    vsWebHookURL.name = "WebHookURL";
    vsWebHookURL.value =  String(this.WebhookURL);

    vsNoAvailabilityMessage.name = "NoAvailabilityMessage";
    vsNoAvailabilityMessage.value =  String(this.NoAvailabilityMessage);

    vsAllowTimeOut.name = "AllowTimeOut";
    vsAllowTimeOut.value =  String(this.AllowTimeOut);

    vsCustomerServiceEmail.name = "CustomerServiceEmail";
    vsCustomerServiceEmail.value = String(this.CustomerServiceEmail ?? "");

    vsCustomerServicePhone.name = "CustomerServicePhone";
    vsCustomerServicePhone.value = String(this.CustomerServicePhone ?? "");

    vsUseCounters.name = "UseCounters";
    vsUseCounters.value =  String(this.UseCounters);

    vsSummaryItinerary.name = "SummaryItinerary";
    vsSummaryItinerary.value =  String(this.SummaryItinerary);

    vsSummaryItineraryVenue.name = "SummaryItineraryVenue";
    vsSummaryItineraryVenue.value = String(this.SummaryItineraryVenue);

    vsIgnoreDateRestrictions.name = "IgnoreDateRestrictions";
    vsIgnoreDateRestrictions.value =  String(this.IgnoreDateRestrictions);

    vsShowSummaryAtBottomOnDesktop.name = "ShowSummaryAtBottomOnDesktop";
    vsShowSummaryAtBottomOnDesktop.value = String(this.ShowSummaryAtBottomOnDesktop);

    vsShowAtAGlanceFigures.name = "ShowAtAGlanceFigures";
    vsShowAtAGlanceFigures.value = String(this.ShowAtAGlanceFigures);

    vsShowGoogleReview.name = "ShowGoogleReview";
    vsShowGoogleReview.value = String(this.ShowGoogleReview);

    vsGoogleReviewId.name = "GoogleReviewId";
    vsGoogleReviewId.value = this.GoogleReviewId;

    vsPublicBookingWizardNotesText.name = "PublicBookingWizardNotesText";
    vsPublicBookingWizardNotesText.value = this.PublicBookingWizardNotesText ?? '';

    vsShowNewBookingsOnAtAGlance.name = "ShowNewBookingsOnAtAGlance";
    vsShowNewBookingsOnAtAGlance.value = String(this.ShowNewBookingsOnAtAGlance);

    vsNotesOnPBW.name = "notesonpbw";
    vsNotesOnPBW.value = String(this.notesonpbw);

    vsAllowResourcesChangedManually.name = "AllowResourcesChangedManually";
    vsAllowResourcesChangedManually.value = String(this.AllowResourcesChangedManually);

    vsReturnResourceSpaceOnCustomerLeaving.name = "ReturnResourceSpaceOnCustomerLeaving";
    vsReturnResourceSpaceOnCustomerLeaving.value = String(this.ReturnResourceSpaceOnCustomerLeaving);

    vsSimRacingEnabled.name = "simracing_enabled";
    vsSimRacingEnabled.value = String(this.SimRacingEnabled);

    vsSimRacingAPiKey.name = "simracing_apikey";
    vsSimRacingAPiKey.value = String(this.SimRacingAPIKey);

    vsSimRacingVenueID.name = "simracing_venueid";
    vsSimRacingVenueID.value = String(this.SimRacingVenueID);

    vsBrevoEnabled.name = "brevo_enabled";
    vsBrevoEnabled.value = String(this.BrevoEnabled);

    vsBrevoAPIKey.name = "brevo_apikey";
    vsBrevoAPIKey.value = String(this.BrevoAPIKey);

    vsMailChimpEnabled.name = "mailchimp_enabled";
    vsMailChimpEnabled.value = String(this.MailChimpEnabled);

    vsMailChimpAPIKey.name = "mailchimp_apikey";
    vsMailChimpAPIKey.value = String(this.MailChimpAPIKey);

    let vsOgTitle = new cVenuesetting;
    vsOgTitle.name = "og_title";
    vsOgTitle.value = String(this.ogTitle);

    let vsOgDescription = new cVenuesetting;
    vsOgDescription.name = "og_description";
    vsOgDescription.value = String(this.ogDescription);

    let vsOgUrl = new cVenuesetting;
    vsOgUrl.name = "og_url";
    vsOgUrl.value = String(this.ogUrl);

    let vsOgImage = new cVenuesetting;
    vsOgImage.name = "og_image";
    vsOgImage.value = String(this.ogImage);

    let vsOgImageGuid = new cVenuesetting;
    vsOgImageGuid.name = "og_image_guid";
    vsOgImageGuid.value = String(this.ogImageGuid);

    let vsOgImageMode = new cVenuesetting;
    vsOgImageMode.name = "og_image_mode";
    vsOgImageMode.value = String(this.ogImageMode);

    let vsMinimalDetails = new cVenuesetting;
    vsMinimalDetailsContainer.name = "MinimalDetails";
    vsMinimalDetailsContainer.value = String(this.vsMinimalDetails);

    let vsImageURL = new cVenuesetting;
    vsImageURLContainer.name = "PublicImgURL";
    vsImageURLContainer.value = String(this.vsImageURL);

    let vsImageReturnURL = new cVenuesetting;
    vsImageReturnURLContainer.name = "ImageReturnURL";
    vsImageReturnURLContainer.value = this.vsImageReturnURL ?? '';

    let vsImageMode = new cVenuesetting;
    vsImageMode.name = "PublicImgMode";
    vsImageMode.value = String(this.vsImageMode);

    let vsImageGuid = new cVenuesetting;
    vsImageGuid.name = "PublicImgGuid";
    vsImageGuid.value = String(this.vsImageGuid);

    let vsGTMCodeContainer = new cVenuesetting;
    vsGTMCodeContainer.name = "GTMCode";
    vsGTMCodeContainer.value = String(this.vsGTMCode);

    let vsImageWidth = new cVenuesetting;
    vsImageWidth.name = "PublicImageWidth";
    vsImageWidth.value = String(this.imageWidth);

    let vsMinWaiverAge = new cVenuesetting;
    vsMinWaiverAge.name = "WaiverMinAge";
    vsMinWaiverAge.value = String(this.MinWaiverAge.value);

    let vsMinWaiverAgeParticipate = new cVenuesetting;
    vsMinWaiverAgeParticipate.name = "MinWaiverAgeParticipate";
    vsMinWaiverAgeParticipate.value = String(this.WaiverMinAgeParticipate.value);

    let vsImageHeight = new cVenuesetting;
    vsImageHeight.name = "PublicImageheight";
    vsImageHeight.value = String(this.imageHeight);

    let vsColour = new cVenuesetting;
    vsColour.name = "DefaultColour";
    vsColour.value = String(this.defaultColour);

    let vsBackgroundColour = new cVenuesetting;
    vsBackgroundColour.name = "DefaultBackgroundVColour";
    vsBackgroundColour.value = String(this.defaultBackgroundColour);

    let vsTextColour = new cVenuesetting;
    vsTextColour.name = "DefaultTextColour";
    vsTextColour.value = String(this.defaultTextColour);

    let vsButtonTextColour = new cVenuesetting;
    vsButtonTextColour.name = "DefaultButtonTextColour";
    vsButtonTextColour.value = String(this.defaultButtonTextColour);

    let vsSummaryBackgroundColour = new cVenuesetting;
    vsSummaryBackgroundColour.name = "DefaultSummaryBackgroundColour";
    vsSummaryBackgroundColour.value = String(this.defaultSummaryBackgroundColour);

    let vsSummaryHeaderFooterColour = new cVenuesetting;
    vsSummaryHeaderFooterColour.name = "DefaultSummaryHeaderFooterColour";
    vsSummaryHeaderFooterColour.value = String(this.defaultSummaryHeaderFooterColour);

    let vsSummaryHeaderFooterTextColour = new cVenuesetting;
    vsSummaryHeaderFooterTextColour.name = "DefaultSummaryHeaderFooterTextColour";
    vsSummaryHeaderFooterTextColour.value = String(this.defaultSummaryHeaderFooterTextColour);

    let vsSummaryTextColour = new cVenuesetting;
    vsSummaryTextColour.name = "DefaultSummaryTextColour";
    vsSummaryTextColour.value = String(this.defaultSummaryTextColour);

    let vsTimezone = new cVenuesetting;
    vsTimezone.name = "TimeZone";
    vsTimezone.value = String(this.chosenTimezone);

    let vsCurrency = new cVenuesetting;
    vsCurrency.name = "Currency";
    vsCurrency.value = String(this.chosenCurrency);

    let vsCulture = new cVenuesetting;
    vsCulture.name = "Culture";
    vsCulture.value = String(this.chosenCulture);

    let vsBookingsCannotBeMadeWithinXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeWithinXMinutes.name = "BookingsCannotBeMadeWithinXMinutes";
    vsBookingsCannotBeMadeWithinXMinutes.value = String(this.BookingsCannotBeMadeWithinXMinutes);

    let vsBookingsCannotBeMadeAfterXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeAfterXMinutes.name = "BookingsCannotBeMadeAfterXMinutes";
    vsBookingsCannotBeMadeAfterXMinutes.value = String(this.BookingsCannotBeMadeAfterXMinutes);

    let vsCannotMakeBookingsToday = new cVenuesetting;
    vsCannotMakeBookingsToday.name = "CannotMakeBookingsToday";
    vsCannotMakeBookingsToday.value = String(this.CannotMakeBookingsToday);

    let vsBetaEmailing = new cVenuesetting;
    vsBetaEmailing.name = "BetaEmailing";
    vsBetaEmailing.value = String(this.betaemailing);

    let vsBetaTask = new cVenuesetting;
    vsBetaTask.name = "BetaTask";
    vsBetaTask.value = String(this.betatask);

    let vsBetamembership = new cVenuesetting;
    vsBetamembership.name = "Betamembership";
    vsBetamembership.value = String(this.betamembership);

    let vsPaymentAmountSelection = new cVenuesetting;
    vsPaymentAmountSelection.name = "PaymentAmountSelection";
    vsPaymentAmountSelection.value = String(this.PaymentAmountSelection);

    let vsChosenHomePage = new cVenuesetting;
    if(this.ChosenHomePage != null)
    {
      vsChosenHomePage.name = "ChosenHomePage";
      vsChosenHomePage.value = String(this.ChosenHomePage.value);
    }

    let vsTillAccess = new cVenuesetting;
    vsTillAccess.name = "TillAccess";
    vsTillAccess.value = String(this.TillAccess);

    let vsWaiverMinAge = new cVenuesetting;
    vsWaiverMinAge.name = "waiverminage";
    vsWaiverMinAge.value = String(this.waiverminage);

    let vsSelectedPaymentLinkEmailTemplate = new cVenuesetting;
    if(this.selectedPaymentLinkEmailTemplate != null)
    {
      vsSelectedPaymentLinkEmailTemplate.name = "PaymentLinkEmailTemplate";
      vsSelectedPaymentLinkEmailTemplate.value = String(this.selectedPaymentLinkEmailTemplate.emailtemplateid);
    }

    let vsSelectedVoucherEmailTemplate = new cVenuesetting;
    if(this.selectedVoucherEmailTemplate != null)
    {
      vsSelectedVoucherEmailTemplate.name = "VoucherEmailTemplate";
      vsSelectedVoucherEmailTemplate.value = String(this.selectedVoucherEmailTemplate.emailtemplateid);
    }

    let vsSelectedCancelledBookingEmailTemplate = new cVenuesetting;
    if(this.selectedCancelledBookingEmailTemplate != null)
    {
      vsSelectedCancelledBookingEmailTemplate.name = "CancelledBookingTemplate";
      vsSelectedCancelledBookingEmailTemplate.value = String(this.selectedCancelledBookingEmailTemplate.emailtemplateid);
    }

    let vsVoucherValidity = new cVenuesetting;
    vsVoucherValidity.name = "vouchervalidity";
    vsVoucherValidity.value = String(this.VoucherValidity);

    let vsWaiverActive = new cVenuesetting;
    vsWaiverActive.name = "WaiverActive";
    vsWaiverActive.value = String(this.WaiversActive);

    let vsCustomerPortalActive = new cVenuesetting;
    vsCustomerPortalActive.name = "CustomerPortalActive";
    vsCustomerPortalActive.value = String(this.CustomerPortalActive);

    let vsCustomerPortalMinPayment = new cVenuesetting;
    vsCustomerPortalMinPayment.name = "CustomerPortalMinPayment";
    vsCustomerPortalMinPayment.value = String(this.CustomerPortalMinPayment);

    let vsConfirmNumberMessage = new cVenuesetting;
    vsConfirmNumberMessage.name = "confirmmessage";
    vsConfirmNumberMessage.value = this.ConfirmNumberMessage;

    let issues: cValidationIssue[] = [];

    let returnURL = (this.vsImageReturnURL == null || this.vsImageReturnURL == '') ? '' : this.vsImageReturnURL.trim();
    if (returnURL !== '' && !returnURL.startsWith('http://') && !returnURL.startsWith('https://')) {
      returnURL = 'https://' + returnURL;
      this.vsImageReturnURL = returnURL;
    }
    if (returnURL == '') {
      this.imageReturnURLValid = false;
      this.imageReturnURLFormatValid = true;
    } else {
      try {
        new URL(returnURL);
        this.imageReturnURLValid = true;
        this.imageReturnURLFormatValid = true;
      } catch {
        this.imageReturnURLValid = true;
        this.imageReturnURLFormatValid = false;
      }
    }

    let returnPageVal = (this.returnPage == null || this.returnPage == '') ? '' : this.returnPage.trim();
    if (returnPageVal !== '' && !returnPageVal.startsWith('http://') && !returnPageVal.startsWith('https://')) {
      returnPageVal = 'https://' + returnPageVal;
    }
    this.returnPage = returnPageVal;
    vsReturnPage.value = String(this.returnPage);
    this.returnPageValid = returnPageVal != '';

    //Collected in page order: General Settings sits above Visual Settings in the accordion.
    if (!this.returnPageValid) {
      issues.push({ message: 'You must enter a Return page for public bookings after payment.', tabIndex: 1, accordionIndex: 0, fieldId: 'returnPage' });
    }

    if (!this.imageReturnURLValid) {
      issues.push({ message: 'You must enter a URL to navigate to when clicking on the Logo.', tabIndex: 1, accordionIndex: 2, fieldId: 'imageReturnURL' });
    }
    else if (!this.imageReturnURLFormatValid) {
      issues.push({ message: 'Please enter a valid Logo URL starting with http:// or https://', tabIndex: 1, accordionIndex: 2, fieldId: 'imageReturnURL' });
    }

    this.reportValidationIssues(issues, showmessage);

    if(issues.length == 0)
    {
      this.venuesettings = {
        id: localStorage.getItem("VenueSettingsID"),
        venueid: this.VenueID,
        venuesettings: [
          vsDiagnosticsContainer,
          vsPBWStyleContainer,
          vsMinimalDetailsContainer,
          vsGTMCodeContainer,
          vsImageURLContainer,
          vsImageReturnURLContainer,
          vsImageMode,
          vsImageGuid,
          vsConfirmation,
          vsDefInterval,
          vsImageWidth,
          vsImageHeight,
          vsIdleTimeout,
          vsAllowTimeOut,
          vsCustomerServiceEmail,
          vsCustomerServicePhone,
          vsUseCounters,
          vsSummaryItinerary,
          vsSummaryItineraryVenue,
          vsIgnoreDateRestrictions,
          vsShowSummaryAtBottomOnDesktop,
          vsShowAtAGlanceFigures,
          vsShowGoogleReview,
          vsGoogleReviewId,
          vsShowNewBookingsOnAtAGlance,
          vsNotesOnPBW,
          vsPublicBookingWizardNotesText,
          vsAllowResourcesChangedManually,
          vsReturnResourceSpaceOnCustomerLeaving,
          vsColour,
          vsBackgroundColour,
          vsTextColour,
          vsButtonTextColour,
          vsSummaryBackgroundColour,
          vsSummaryHeaderFooterColour,
          vsSummaryHeaderFooterTextColour,
          vsSummaryTextColour,
          vsRyftSubAccountID,
          vsGoogleTagManagerID,
          vsReturnPage,
          vsWebHookURL,
          vsNoAvailabilityMessage,
          vsTimezone,
          vsCurrency,
          vsCulture,  
          vsSelectedPaymentLinkEmailTemplate,
          vsChosenHomePage,
          vsTillAccess,
          vsWaiverMinAge,
          vsSelectedVoucherEmailTemplate,
          vsSelectedCancelledBookingEmailTemplate,
          vsVoucherValidity,
          vsBookingsCannotBeMadeAfterXMinutes,
          vsBookingsCannotBeMadeWithinXMinutes,
          vsCannotMakeBookingsToday,
          vsBetaEmailing,
          vsBetaTask,
          vsBetamembership,
          vsBookingNotificationEmail,
          vsBookingNotification,
          vsStopPublicBookings,
          vsWaiverActive,
          vsCustomerPortalActive,
          vsCustomerPortalMinPayment,
          vsConfirmNumberMessage,
          vsMinWaiverAge,
          vsMinWaiverAgeParticipate,
          vsSimRacingEnabled,
          vsSimRacingAPiKey,
          vsSimRacingVenueID,
          vsBrevoEnabled,
          vsBrevoAPIKey,
          vsMailChimpEnabled,
          vsMailChimpAPIKey,
          vsOgTitle,
          vsOgDescription,
          vsOgUrl,
          vsOgImage,
          vsOgImageGuid,
          vsOgImageMode
        ]
      };

      // Device-local settings — saved per device per venue, never in the DB
      localStorage.setItem(`TillName_${this.VenueID}`, this.TillName?.trim() ?? '');
      localStorage.setItem(`TerminalName_${this.VenueID}`, this.selectedTerminal?.value ?? '');
      localStorage.setItem(`GeneralTerminalName_${this.VenueID}`, this.selectedGeneralTerminal?.value ?? '');

      this.http.put<cVenuesettings>(bmxurl + "/venuesettings", this.venuesettings).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            if(showmessage)
              this.messageService.add({severity:'success', summary:'Saved', detail:'Venue Settings successfully updated'});

            //Reload VenueSettings
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
              this.httpResponse =  (response as venuesettings_returndata)
              if(this.httpResponse.succeeded)
              {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

                this.httpResponse.data.venueSettings.forEach((element: any) => {
                  if (this.deviceLocalKeys.includes(element.name)) return;
                  localStorage.removeItem(element.name);
                  localStorage.setItem(element.name, element.value);
                });

                // Re-apply device-local settings after DB reload to prevent any stale DB entry overwriting them
                localStorage.setItem(`TillName_${this.VenueID}`, this.TillName?.trim() ?? '');
                localStorage.setItem(`TerminalName_${this.VenueID}`, this.selectedTerminal?.value ?? '');
                localStorage.setItem(`GeneralTerminalName_${this.VenueID}`, this.selectedGeneralTerminal?.value ?? '');
              }
              else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });

          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Venue Settings Not Saved', detail:error.messages});
        })
    }
  }

  //report is only set when the user actually presses Save. The (keyup) handlers on the
  //Venue Details inputs call this on every keystroke purely to update the red highlighting,
  //and must not raise toasts or move the page while someone is typing.
  DoValidCheck(report: boolean = false)
  {
    let issues: cValidationIssue[] = [];

    //Issues are collected in the order the fields appear on the page, so the first one
    //reported is the topmost one the user needs to fix.
    this.venueNameValid = !(this.Venue.data.name == null || this.Venue.data.name == "");
    if(!this.venueNameValid)
    {
      issues.push({ message: 'You must enter a Venue name.', tabIndex: 0, fieldId: 'VenueName' });
    }

    this.addressValid = !(this.Venue.data.address1 == null || this.Venue.data.address1 == "");
    if(!this.addressValid)
    {
      issues.push({ message: 'You must enter an Address.', tabIndex: 0, fieldId: 'Address1' });
    }

    this.townValid = !(this.Venue.data.town == null || this.Venue.data.town == "");
    if(!this.townValid)
    {
      issues.push({ message: 'You must enter a Town/City.', tabIndex: 0, fieldId: 'Town' });
    }

    this.countyValid = !(this.Venue.data.county == null || this.Venue.data.county == "");
    if(!this.countyValid)
    {
      issues.push({ message: 'You must enter a County.', tabIndex: 0, fieldId: 'County' });
    }

    this.postcodeValid = !(this.Venue.data.postcode == null || this.Venue.data.postcode == "");
    if(!this.postcodeValid)
    {
      issues.push({ message: 'You must enter a Postcode.', tabIndex: 0, fieldId: 'PostCode' });
    }

    this.phoneValid = !(this.Venue.data.telephone == null || this.Venue.data.telephone == "");
    if(!this.phoneValid)
    {
      issues.push({ message: 'You must enter a Telephone number.', tabIndex: 0, fieldId: 'Telephone' });
    }

    this.emailValid = !(this.Venue.data.email == null || this.Venue.data.email == "");
    if(!this.emailValid)
    {
      issues.push({ message: 'You must enter an Email.', tabIndex: 0, fieldId: 'Email' });
    }

    //The Venue Capacity input is commented out of the template, so there is no field to
    //jump to - the toast is the only way the user finds out this is what is blocking them.
    this.capacityValid = !(this.Venue.data.capacity == 0);
    if(!this.capacityValid)
    {
      issues.push({ message: 'You must enter a Venue Capacity greater than zero.', tabIndex: 0 });
    }

    this.prefixValid = !(this.Venue.data.prefix == null || this.Venue.data.prefix == "");
    if(!this.prefixValid)
    {
      issues.push({ message: 'You must enter a Booking ID Prefix.', tabIndex: 0, fieldId: 'prefix' });
    }

    if (report) {
      this.reportValidationIssues(issues);
    }

    return issues.length == 0;
  }

  //Raises a toast for every validation failure, then opens the tab/accordion holding the
  //first one and puts the cursor in it. Without this the errors are invisible whenever the
  //offending field sits on a tab or in an accordion panel the user isn't currently looking at.
  //jump is false for the background saves behind the waiver/customer portal toggles - the
  //user still needs to be told why nothing saved, but yanking them onto another tab
  //mid-toggle would be worse than leaving them where they are.
  private reportValidationIssues(issues: cValidationIssue[], jump: boolean = true): void {
    if (issues.length == 0) {
      return;
    }

    issues.forEach(issue => {
      this.messageService.add({ severity: 'error', summary: 'Cannot Save', detail: issue.message, life: 8000 });
    });

    if (!jump) {
      return;
    }

    const first = issues[0];

    this.activeTabIndex = first.tabIndex;

    if (first.accordionIndex != null) {
      this.settingsAccordionIndex = first.accordionIndex;
    }

    this.jumpToField(first.fieldId);
  }

  //Waits for the tab/accordion to finish rendering before scrolling, otherwise the target
  //field still has no layout box and scrollIntoView does nothing.
  private jumpToField(fieldId?: string): void {
    setTimeout(() => {
      const field = fieldId == null ? null : document.getElementById(fieldId);

      if (field != null) {
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        field.focus({ preventScroll: true });
        return;
      }

      this.scrollToFirstError();
    }, 300);
  }

  private scrollToFirstError(): void {
    setTimeout(() => {
      const errors = Array.from(document.querySelectorAll('.text-danger'));
      const visible = errors.find(el => (el as HTMLElement).offsetParent !== null);
      if (visible) {
        visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);
  }

  getContrastColour(hexColour: string): string {
    const hex = (hexColour || '#ffffff').replace('#', '');
    if (hex.length < 6) return '#000000';
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }

  onBackgroundColourChange() {
    this.defaultTextColour = this.getContrastColour(this.defaultBackgroundColour);
  }

  onButtonColourChange() {
    this.defaultButtonTextColour = this.getContrastColour(this.defaultColour);
  }

}
